import { createSlice } from '@reduxjs/toolkit';
import { ImageModelSchema, useAppSelector } from 'shared';
// eslint-disable-next-line no-restricted-imports
import {
    fetchCrewMembersThunk,
} from 'shared/lib';
import { CrewMemberModel, CrewMemberModelSchema } from 'entities/crew-member';
import BaseError from '../../../utils/base-error';

export type CrewMembersBlockState = {
    loaded: boolean
    crewMembers: CrewMemberModel[]
}

const initialState: CrewMembersBlockState = {
    loaded: false,
    crewMembers: [],
};

// eslint-disable-next-line import/prefer-default-export
export const crewMembersBlockSlice = createSlice({
    name: 'crewMembersBlockSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCrewMembersThunk.fulfilled, (state, action) => {
            const response = action.payload;

            if (response instanceof BaseError) {
                // TODO
            } else {
                // Валидация
                try {
                    state.crewMembers = response.data.data?.map(
                        ({
                            documentId,
                            name,
                            jobTitle,
                            description,
                            position,
                            image,
                        }) => CrewMemberModelSchema.parse({
                            uid: documentId,
                            name,
                            jobTitle,
                            description,
                            position,
                            image: image && ImageModelSchema.parse({
                                url: image.url,
                            }),
                        }),
                    ).sort((a, b) => {
                        const aPos = a.position || Infinity;
                        const bPos = b.position || Infinity;

                        return aPos - bPos;
                    }) || [];
                    state.loaded = true;
                } catch (e) {
                    // return new BaseError(400, String(e));
                    // TODO
                }
            }
        });
    },
});

export const useCrewMembersBlockState = () => useAppSelector((store) => store.crewMembersBlock);
